// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"517":"42dc7737","716":"83020ec4"}[chunkId] + ".chunk.css";
};